export const averageCostingFieldpath = (index, chIndex) => {
  return {
    COLOURWAY_TOTAL: 'averageCosting.colourwayTot',
    SUM_QUANTITY_PER_SIZ_COl: 'averageCosting.sumOfQuantityPerSizCol',
    PRICE_PER_UNIT_TOTAL: 'averageCosting.totalPricePerUnit',
    SELECTED_COLOURWAY: `averageCosting.averageCostingInfo[${index}].colourway`,
    SELECTED_SIZE: `averageCosting.averageCostingInfo[${index}].size`,
    SELECTED_LENGTH: `averageCosting.averageCostingInfo[${index}].length`,
    QUANTITY_PER_SIZCOL: `averageCosting.averageCostingInfo[${index}].quantityPerSizCol`,
    PRICE_PER_UNIT: `averageCosting.averageCostingInfo[${index}].pricePerUnit`,
    LENGTH_TOTAL: 'averageCosting.lengthTot',
    SIZE_TOTAL: 'averageCosting.sizeTot',
    AVERAGE_COSTING_INFO: 'averageCosting.averageCostingInfo',
    AVERAGE_COSTING_ACTIVE: 'averageCosting.averageCostingActive',
    SUM_TOTAL_PRICE: 'averageCosting.sumTotalPrice',
    // new changes
    EXPAND_QUANTITY_PER_SIZ_COL: `averageCosting.averageCostingInfo[${index}].expandData[${chIndex}].quantityPerSizCol`,
    EXPAND_PRICE_PER_UNIT: `averageCosting.averageCostingInfo[${index}].expandData[${chIndex}].pricePerUnit`,
    EXPAND_TOTAL_PRICE: `averageCosting.averageCostingInfo[${index}].expandData[${chIndex}].totalPricePerUnit`,
    EXPAND_SUM_TOTAL_PRICE: `averageCosting.averageCostingInfo[${index}].sumTotalPrice`,
    EXPAND_SUM_QUANTITY_PER_COL_SIZ: `averageCosting.averageCostingInfo[${index}].sumOfQuantityPerSizCol`,
    EXPAND_SUM_PRICE_PER_UNIT: `averageCosting.averageCostingInfo[${index}].sumOfPricePerUnit`,
    EXPAND_OVERALL_SUM_TOTAL_PRICE: 'averageCosting.overAllSumOfTotalPrice',
    EXPAND_OVERALL_SUM_QUANTITY_PER_COL_SIZ: 'averageCosting.overAllSumOfQuantityPerSizCol',
    EXPAND_OVERALL_SUM_PRICE_PER_UNIT: 'averageCosting.overAllSumOfPricePerUnit',
    IS_CHANGED_BY_SUPPLIER_PRICE_PER_UNIT: `averageCosting.averageCostingInfo[${index}].expandData[${chIndex}].isChangedBySupllierPricePerUnit`,
    LOADER: 'averageCosting.loader',
    TOTAL_AVERAGE_COLOURWAYS: 'averageCosting.totColourways',
    TOTAL_AVERAGE_SIZES: 'averageCosting.totSize',
    TOTAL_AVERAGE_LENGTH: 'averageCosting.totLength',
  };
};

export const detailedCostingFieldpath = (index, chIndex, expIndex) => {
  return {
    TOTAL_QUANTITY: `detailedCosting.bomTypeArr[${index}].detailedCostingInfo[${chIndex}].totalQuantity`,
    TOTAL_PRICE: `detailedCosting.bomTypeArr[${index}].detailedCostingInfo[${chIndex}].totalPricePerUnit`,
    SELECTED_COLOURWAY: `detailedCosting.bomTypeArr[${index}].detailedCostingInfo[${chIndex}].colourway`,
    SELECTED_SIZE: `detailedCosting.bomTypeArr[${index}].detailedCostingInfo[${chIndex}].size`,
    SELECTED_LENGTH: `detailedCosting.bomTypeArr[${index}].detailedCostingInfo[${chIndex}].length`,
    QUANTITY_PER_UNIT: `detailedCosting.bomTypeArr[${index}].detailedCostingInfo[${chIndex}].quantityPerSizCol`,
    PRICE_PER_UNIT: `detailedCosting.bomTypeArr[${index}].detailedCostingInfo[${chIndex}].pricePerUnit`,
    UOM_ONE_SELECTED: `detailedCosting.bomTypeArr[${index}].detailedCostingInfo[${chIndex}].quantityUom`,
    UOM_TWO_SELECTED: `detailedCosting.bomTypeArr[${index}].detailedCostingInfo[${chIndex}].totalQuantityUom`,
    DETAILED_COSTING_ACTIVE: 'detailedCosting.detailedCostingActive',
    DETAILED_COSTING_DATA: 'detailedCosting.bomTypeArr',
    COLOUR_REF: `detailedCosting.bomTypeArr[${index}].detailedCostingInfo[${chIndex}].colourRef`,
    COLOUR_REF_OPTION: `detailedCosting.bomTypeArr[${index}].detailedCostingInfo[${chIndex}].colourRefOptions`,
    SUM_TOTAL_PRICE: 'detailedCosting.sumTotalPrice',
    SUM_TOTAL_QUANTITY: `detailedCosting.bomTypeArr[${index}].sumOfTotalQuantity`,
    LENGTH_TOTAL: `detailedCosting.bomTypeArr[${index}].lengthTot`,
    SIZE_TOTAL: `detailedCosting.bomTypeArr[${index}].sizeTot`,
    COLOURWAY_TOTAL: `detailedCosting.bomTypeArr[${index}].colourwayTot`,
    SUM_QUANTITY_PER_SIZ_COl: `detailedCosting.bomTypeArr[${index}].sumOfQuantityPerSizCol`,
    PRICE_PER_UNIT_TOTAL: `detailedCosting.bomTypeArr[${index}].totalPricePerUnit`,
    COPY_DATA: `detailedCosting.bomTypeArr[${index}].detailedCostingInfo[${chIndex}]`,
    IS_CHANGED_BY_SUPPLIER_PRICE_PER_UNIT: `detailedCosting.bomTypeArr[${index}].detailedCostingInfo[${chIndex}].expandData[${expIndex}].isChangedBySupplierPricePerUnit`,
    IS_CHANGED_BY_SUPPLIER_QUANTITY_UOM: `detailedCosting.bomTypeArr[${index}].detailedCostingInfo[${chIndex}].expandData[${expIndex}].isChangedBySupplierQuantityUom`,
    IS_CHANGED_BY_SUPPLIER_QUANTITY_PER_SIZE_COl: `detailedCosting.bomTypeArr[${index}].detailedCostingInfo[${chIndex}].expandData[${expIndex}].isChangedBySupplierTotalQuantityPerSizCol`,
    IS_CHANGED_BY_SUPPLIER_TOTAL_PRICE: `detailedCosting.bomTypeArr[${index}].detailedCostingInfo[${chIndex}].expandData[${expIndex}].isChangedBySupplierTotalPrice`,
    // new changess
    EXPAND_QUANTITY_PER_SIZ_COL: `detailedCosting.bomTypeArr[${index}].detailedCostingInfo[${chIndex}].expandData[${expIndex}].quantityPerSizCol`,
    EXPAND_PRICE_PER_UNIT: `detailedCosting.bomTypeArr[${index}].detailedCostingInfo[${chIndex}].expandData[${expIndex}].pricePerUnit`,
    EXPAND_QUANTITY_PER_SIZ_COL_UOM: `detailedCosting.bomTypeArr[${index}].detailedCostingInfo[${chIndex}].expandData[${expIndex}].quantityUom`,
    EXPAND_TOTAL_PRICE: `detailedCosting.bomTypeArr[${index}].detailedCostingInfo[${chIndex}].expandData[${expIndex}].totalPrice`,
    EXPAND_SUM_TOTAL_PRICE: `detailedCosting.bomTypeArr[${index}].detailedCostingInfo[${chIndex}].sumTotalPrice`,
    EXPAND_SUM_QUANTITY_PER_COL_SIZ: `detailedCosting.bomTypeArr[${index}].detailedCostingInfo[${chIndex}].sumOfQuantityPerSizCol`,
    EXPAND_SUM_PRICE_PER_UNIT: `detailedCosting.bomTypeArr[${index}].detailedCostingInfo[${chIndex}].sumOfPricePerUnit`,
    EXPAND_COLOUR_REF: `detailedCosting.bomTypeArr[${index}].detailedCostingInfo[${chIndex}].expandData[${expIndex}].colourRef`,
    BOM_QUANTITY_UOM: `detailedCosting.bomTypeArr[${index}].quantityUnitOfMeasure`,
    BOM_DETAILED_COSTING_DATA: `detailedCosting.bomTypeArr[${index}].detailedCostingInfo`,
    IS_EXCLUDED: `detailedCosting.bomTypeArr[${index}].detailedCostingInfo[${chIndex}].expandData[${expIndex}].isExcluded`,
  };
};

export const testingFieldpath = (index) => {
  return {
    TOTAL_PRICE: `testing.testingInfo[${index}].totalPrice`,
    SELECTED_COLOURWAY: `testing.testingInfo[${index}].colourway`,
    SELECTED_TEST_CODE: `testing.testingInfo[${index}].testingCode`,
    TESTING_DESC: `testing.testingInfo[${index}].testingDesc`,
    TESTING_TYPE: `testing.testingInfo[${index}].testingType`,
    IS_EXCLUDED: `testing.testingInfo[${index}].isExcluded`,
    SUM_PRICE: 'testing.sumOfPrice',
    TESTING_INFO_DATA: 'testing.testingInfo',
    COLOUR_REF: `testing.testingInfo[${index}].colourRef`,
    COLOUR_REF_OPTION: `testing.testingInfo[${index}].colourRefOptions`,
    BOM_COMPONENT: `testing.testingInfo[${index}].bomComponent`,
    IS_CHANGED_BY_SUPPLIER_TOTAL_PRICE: `testing.testingInfo[${index}].isChangedBySupplierTotalPrice`,
    IS_CHANGED_BY_SUPPLIER_PRICE_PER_UNIT: `testing.testingInfo[${index}].isChangedBySupplierPricePerUnit`,
    PRICE_PER_UNIT: `testing.testingInfo[${index}].pricePerUnit`,
    COPY_DATA: `testing.testingInfo[${index}]`,
  };
};

export const additionalFieldPath = (index) => {
  return {
    SELECTED_TEMP_ADDTIONAL_DATA: 'additional.additionalInfo',
    SELECTED_COLOURWAY: `additional.additionalInfo[${index}].colourway`,
    UOM_ONE_SELECTED: `additional.additionalInfo[${index}].quantityUom`,
    UOM_TWO_SELECTED: `additional.additionalInfo[${index}].totalQuantityUom`,
    TOTAL_PRICE: `additional.additionalInfo[${index}].totalPrice`,
    TOTAL_QUANTITY: `additional.additionalInfo[${index}].totalQuantity`,
    QUANTITY_PER_UNIT: `additional.additionalInfo[${index}].quantityPerColSizLen`,
    PRICE_PER_UNIT: `additional.additionalInfo[${index}].pricePerUoM`,
    ITEM: `additional.additionalInfo[${index}].title`,
    IS_CHANGED_BY_SUPPLIER_COLOURWAY: `additional.additionalInfo[${index}].isChangedBySupplierColourway`,
    IS_CHANGED_BY_SUPPLIER_QUANTITY_UOM: `additional.additionalInfo[${index}].isChangedBySupplierQuantityUom`,
    IS_CHANGED_BY_SUPPLIER_TOTAL_QUANTITY_UOM: `additional.additionalInfo[${index}].isChangedBySupplierTotalQuantityUom`,
    IS_CHANGED_BY_SUPPLIER_TOTAL_PRICE: `additional.additionalInfo[${index}].isChangedBySupplierTotalPrice`,
    IS_CHANGED_BY_SUPPLIER_TOTAL_QUANTITY: `additional.additionalInfo[${index}].isChangedBySupplierTotalQuantity`,
    IS_CHANGED_BY_SUPPLIER_QUANTITY_PER_SIZE_COl: `additional.additionalInfo[${index}].isChangedBySupplierTotalQuantityPerSizColLen`,
    IS_CHANGED_BY_SUPPLIER_PRICE_PER_UOM: `additional.additionalInfo[${index}].isChangedBySupplierPricePerUom`,
    IS_CHANGED_BY_SUPPLIER_TITLE: `additional.additionalInfo[${index}].isChangedBySupplierTitle`,
    IS_CHANGED_BY_SUPPLIER_PRICE_PER_UNIT: `additional.additionalInfo[${index}].isChangedBySupplierPricePerUnit`,
    SUM_TOTAL_PRICE: 'additional.sumOfTotPrice',
  };
};

export const landedInfoFieldPath = (index, chIndex) => {
  return {
    SELECTED_COLOURWAY: `landedInfo.landedInfoArr[${index}].colourway`,
    SELLING_PRICE: `landedInfo.landedInfoArr[${index}].sellingPrice`,
    VAT: `landedInfo.landedInfoArr[${index}].vat`,
    LANDED_INFO_DATA: 'landedInfo.landedInfoArr',
    LANDED_DYNAMIC_COL_VALUE: `landedInfo.landedInfoArr[${index}].landedInfoRowArr[${chIndex}].colValue`,
    SELECTED_SIZE: `landedInfo.landedInfoArr[${index}].size`,
    LANDED_COST: `landedInfo.landedInfoArr[${index}].landedCost`,
    GROSS_PROFIT: `landedInfo.landedInfoArr[${index}].profit`,
    MARGIIN_PERCENT: `landedInfo.landedInfoArr[${index}].marginPercent`,
    LANDED_INFO_DYNAMIC_COLUMN: 'landedInfo.landedInfoColumnArr',
    MARKUP: `landedInfo.landedInfoArr[${index}].markup`,
    LANDED_INFO_SELECTED_CURRENCY: 'landedInfo.currency',
    SELECTED_LENGTH: `landedInfo.landedInfoArr[${index}].length`,
    LANDED_INFO_VAT: 'landedInfo.vat',
    LANDEDINFO_CURRENCY_ARR: 'landedInfo.productCurreArr',
  };
};

export const productInfoFieldPath = () => {
  return {
    SELECTED_SUPPLIER: 'productInfo.supplierId',
    SELECTED_CURRENCY: 'productInfo.currency',
    SELECTED_INCOTERMS: 'productInfo.incoterms',
    REFERENCE: 'productInfo.reference',
    SELECTED_SHIPMENT_METHOD: 'productInfo.shipmentMethod',
    TARGET_COST: 'productInfo.targetCost',
  };
};

export const grandTotal = (index) => {
  return {
    SELECTED_COLOURWAY: `grandTotal.grandTotalInfo[${index}].colourway`,
    SELECTED_SIZE: `grandTotal.grandTotalInfo[${index}].size`,
    SELECTED_LENGTH: `grandTotal.grandTotalInfo[${index}].length`,
    PRICE_PER_COLOURWAY_SIZE_LENGTH: `grandTotal.grandTotalInfo[${index}].pricePerColSizLeng`,
    TOTAL_PRICE: 'grandTotal.totalPrice',
  };
};

export const commonPath = () => {
  return {
    COLOURWAY_OPTIONS: 'colourwayOptionsArr',
    COLOURWAY_REF_OPTIONS: 'colourRefOptionsArr',
    LENGTH_OPTIONS: 'lengthOptionsArr',
    SIZE_OPtIONS: 'sizeOptionsArr',
    UOM_OPTIONS: 'uomOptionsArr',
    SUPPLIER_OPTIONS: 'supplierOptionsArr',
    TEST_CODE_OPTIONS: 'testCodeOptionsArr',
    PRODUCT_INFO: 'productInfo',
    STATUS: 'status',
    SELECTED_TEMPLATE: 'productTemplate',
    PRODUCT_ID: 'productId',
    ISBREAKDOWN: 'isBreakdown',
    SELECTED_COSTING_TEMP: 'costingTemplate',
    ISBREAKDOWNMANUALTOGGLE: 'isBrekdownManualToggle',
  };
};

export const quantitiesFieldpath = (index, chIndex) => {
  return {
    COLOURWAY_TOTAL: 'quantities.colourwayTot',
    SUM_QUANTITY_PER_SIZ_COl: 'quantities.sumOfQuantityPerSizCol',
    PRICE_PER_UNIT_TOTAL: 'quantities.totalPricePerUnit',
    SELECTED_COLOURWAY: `quantities.quantitiesInfo[${index}].colourway`,
    SELECTED_SIZE: `quantities.quantitiesInfo[${index}].size`,
    SELECTED_LENGTH: `quantities.quantitiesInfo[${index}].length`,
    QUANTITY_PER_SIZCOL: `quantities.quantitiesInfo[${index}].quantityPerSizCol`,
    LENGTH_TOTAL: 'quantities.lengthTot',
    SIZE_TOTAL: 'quantities.sizeTot',
    QUANTITES_INFO: 'quantities.quantitiesInfo',
    TOTAL_QUANTITY: `quantities.quantitiesInfo[${index}].totalQuantity`,
    SUM_TOTAL_PRICE: 'quantities.sumTotalPrice',
    SUM_TOTAL_QUANTITY: 'quantities.sumOfTotalQuantity',
    // new added fiels
    EXPAND_OVERALL_SUM_QUANTITY_PER_COL_SIZ: 'quantities.overAllSumOfQuantityPerSizCol',
    EXPAND_QUANTITY_PER_SIZCOL: `quantities.quantitiesInfo[${index}].expandData[${chIndex}].quantityPerSizCol`,
    TOTAL_AVERAGE_COLOURWAYS: 'quantities.totColourways',
    TOTAL_AVERAGE_SIZES: 'quantities.totSize',
    TOTAL_AVERAGE_LENGTH: 'quantities.totLength',
  };
};

export const errorpath = (index, chIndex, exIndex) => {
  return {
    AVERAGE: {
      ERROR_PRICE_PER_UNIT: `averageCosting[${index}][${chIndex}].pricePerUnit`,
      ERROR_QUANTITY: `averageCosting[${index}][${chIndex}].quantityPerSizCol`,
    },
    DETAILED: {
      ERROR_PRICE_PER_UNIT: `detailedCosting[${index}][${chIndex}][${exIndex}].pricePerUnit`,
      ERROR_QUANTITY: `detailedCosting[${index}][${chIndex}][${exIndex}].quantityPerSizCol`,
      ERROR_UOM: `bomDataError[${index}].quantityUnitOfMeasure`,
    },
    QUANTITIES: {
      ERROR_QUANTITY: `quantities[${index}][${chIndex}].quantityPerSizCol`,
    },
    PRODUCTINFO: {
      ERROR_SUPPLIER: 'productInfo.supplierId',
      ERROR_INCOTERMS: 'productInfo.incoterms',
      ERROR_CURRENCY: 'productInfo.currency',
      ERROR_TARGETCOST: 'productInfo.currency',
    },
    SELECT_TEMPLATE: 'productTemplate',
    SELECT_COSTING: 'costingTemplate',

    LANDED: {
      ERROR_COLOURWAY: `landedInfo.[${index}].colourway`,
      ERROR_SIZE: `landedInfo.[${index}].size`,
      ERROR_LENGTH: `landedInfo.[${index}].length`,
      ERROR_LANDED_COST: `landedInfo.[${index}].landedCost`,
      ERROR_COL_VALUE: `landedInfo.[${index}][${chIndex}].colValue`,
      ERROR_SELLINGPRICE: `landedInfo.[${index}].sellingPrice`,
    },
    TESTING: {
      ERROR_COLOURWAY: `testing.[${index}].colourway`,
      ERROR_TOTPRICE: `testing.[${index}].totalPrice`,
    },
    ADDITIONAL: {
      ERROR_COLOURWAY: `additional.[${index}].colourway`,
      ERROR_TITLE: `additional.[${index}].title`,
      ERROR_QUANTITY: `additional.[${index}].quantityPerColSizLen`,
      ERROR_QUANTITY_UOM: `additional.[${index}].quantityUom`,
      ERROR_TOTAL_QUANTITY_UOM: `additional.[${index}].totalQuantityUom`,
      ERROR_PRICEPER_UNIT: `additional.[${index}].pricePerUoM`,
    },
  };
};
